import React, {useEffect, useState} from 'react';
import './style.css'
import {TeacherTestItems} from "./teacher-test-items/Teacher-test-items";
import {TeacherTestRowThead} from "./teacher-test-row-thead/Teacher-test-row-thead";
import {TeacherTestSearch} from "./teacher-test-search/Teacher-test-search";

import {useAppDispatch, useAppSelector} from "common/hook";
import {Preloader} from "components/layout/preloader/Preloader";
import {NothingYetMessage} from "../../../../personal-cabinet/nothing-yet-message/NothingYetMessage";
import {useSearchInputChangeHandler} from "common/hook/searchUtils";
import {CustomPagination} from "components/pagination/CustomPagination";
import {getTests} from "features/model/service/test/getTests";


export const TeacherTabs = () => {
    const dispatch = useAppDispatch()
    const testTeacherState = useAppSelector(state => state.testTeacher)
    const {isLoading, tests, pagination} = testTeacherState;
    const {pageSize, pageCount, page} = pagination

    const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
    const [searchQuery, setSearchQuery] = useState('');

    const [sortDirection, setSortDirection] = useState('asc');
    const [sortBy, setSortBy] = useState('author');


    const handleSortChange = (newSortDirection: string, newSortBy: string) => {
        setSortDirection(newSortDirection);
        setSortBy(newSortBy);
    };

    useEffect(() => {
        const params = {
            sort: `${sortDirection === 'desc' ? '-' : ''}${sortBy}`,
            search: debouncedSearchQuery,
            my_tests: 0,
        };
        dispatch(getTests(params));
    }, [dispatch, debouncedSearchQuery, sortBy, sortDirection]);



    const handleSearchInputChange = useSearchInputChangeHandler(
        setDebouncedSearchQuery
    );


    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(getTests({page: value - 1}));
    };


    return (
        <div className="tabs-content">
            <div className="tab">

                {/*Search*/}
                <TeacherTestSearch
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    onSearchInputChange={handleSearchInputChange}
                />

                <div className="data-tbl tests-tbl">

                    {/*sorting*/}
                    <TeacherTestRowThead onSortChange={handleSortChange} sortDirection={sortDirection} sortBy={sortBy}/>

                    {isLoading ? (
                        <Preloader/>
                    ) : tests.length > 0 ? (
                        tests
                            .filter((test) => test.title.toLowerCase().includes(searchQuery.toLowerCase()))
                            .map((test) => (
                                <TeacherTestItems test={test} key={test.id}/>
                            ))
                    ) : (
                        <NothingYetMessage/>
                    )}

                </div>
            </div>
            {pageCount > 1 && (
                <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle}/>
            )}

        </div>
    );
};



// {isLoading ? (
//     <Preloader/>
// ) : (
//     tests && tests.length > 0 ? (
//         tests.map((test) => (
//             <TeacherTestItems test={test} key={test.id}/>
//         ))
//     ) : (
//         <NothingYetMessage/>
//     )
// )}
